<template>
  <section class="attractions-section" aria-label="Discover Alabama">
    <h2 class="find-sweet-spot-title">Find Your Alabama Sweet Spot</h2>
    <p class="find-sweet-spot-txt">Find the sweetest Alabama vacation spot perfectly suited just for you. Customize your next Alabama vacation by the type of experience you are looking for, then filter by the region of Alabama you want to visit. Don't know what your Alabama destination should be? Let our interactive location map be your guide. Now, where is your next Alabama Sweet Spot?</p>
    <div class="container-fluid" v-if="Filters">
      <div class="col-lg-12 attractions-filter--options text-center articles-container" v-if="Filters && Filters.experiences">
        <!-- Experience Type Btn - Mobile -->
         <button
            v-b-modal.exp-modal variant="primary"
            class="filter-button experience-select mobile"
            :class="{ 'filter-active': filters.experience.length > 0, 'experience-select-active': isActive }"
            :aria-selected="experienceFilterSelectedModal || filters.experience.length > 0"
          >
            <span class="experience-select-txt">
              Experience Type
            </span>
            <span>
              <IconBase variant="angle-down" :classes="isActive ? 'arrow' : ''" />
            </span>
        </button>
        <!-- Experience Type Btn - Desktop -->
        <button
          class="filter-button experience-select desktop"
          @click="toggleFilterDropdown('experience')"
          :class="{ 'filter-active': filters.experience.length > 0, 'experience-select-active': isActive }"
          :aria-selected="experienceFilterSelected || filters.experience.length > 0"
        >
          <span class="experience-select-txt">
            Experience Type
          </span>
          <span>
            <IconBase variant="angle-down" size="16" :classes="isActive ? 'arrow' : ''" />
          </span>
        </button>
        <!-- Location Btn - Mobile -->
        <button
          @click="toggleFilterDropdown('location')"
          class="filter-button location-select mobile"
          :class="{ 'filter-active': filters.experience.length > 0, 'location-select-active': isActiveLocation }"
          :aria-selected="experienceFilterSelectedModal || filters.experience.length > 0"
        >
          <span class="location-select-txt">
            Location
          </span>
          <span>
            <IconBase variant="angle-down" size="16" :classes="isActiveLocation ? 'arrow' : ''" />
          </span>
        </button>
        <!-- Location Btn - Desktop -->
        <button
          class="filter-button location-select desktop"
          @click="toggleFilterDropdown('location')"
          :class="{ 'filter-active': filters.experience.length > 0, 'location-select-active': isActiveLocation }"
          :aria-selected="locationFilterSelected || filters.experience.length > 0"
        >
          <span class="location-select-txt">
            Location
          </span>
          <span>
            <IconBase variant="angle-down" size="16" :classes="isActiveLocation ? 'arrow' : ''" />
          </span>
        </button>
        <div class="filter-dropdown-container">
          <!-- Experience Type Content - Mobile -->
          <b-modal id="exp-modal" ref="exp-modal" size="xl" title="" hide-header hide-footer no-fade v-show="this.experienceFilterSelectedModal">
            <a href="#" @click.prevent="hideModal('exp')" class="icon-close modal-icon-close-exp"></a>
              <fieldset class="article-filter-dropdown experience" >
                <legend class="exp-title-txt">Choose an Experience</legend>
                <ol class="filter-experience-container">
                  <li v-for="(exp) in this.experiences" :key="exp.slug">
                    <button class="experience-filter"
                     @click="selectExperienceFilter(exp.slug)" :aria-selected="pendingFilters.experience.includes(exp.slug)">
                      <img :src="exp.iconUrl" :alt="`An icon for the ${exp.text}`" />
                      <span>{{ exp.text }}</span>
                    </button>
                  </li>
                </ol>
                <button @click="handleExperienceType('mobile')" class="filter-save-button">Save</button>
              </fieldset>
          </b-modal>
          <!-- Experience Type Content - Desktop -->
          <fieldset v-show="this.experienceFilterSelected" class="article-filter-dropdown experience" >
            <legend>Choose an Experience</legend>
            <ol class="filter-experience-container">
              <li v-for="(exp) in this.experiences" :key="exp.slug">
                <button class="experience-filter"
                 @click="selectExperienceFilter(exp.slug)" :aria-selected="pendingFilters.experience.includes(exp.slug)">
                  <img :src="exp.iconUrl" :alt="`An icon for the ${exp.text}`" />
                  <span>{{ exp.text }}</span>
                </button>
              </li>
            </ol>
            <button @click="handleExperienceType('desktop')" class="filter-save-button">Save</button>
          </fieldset>
          <!-- Location Content - Desktop -->
          <fieldset v-show="this.locationFilterSelected" class="article-filter-dropdown location" >
            <FilterByLocation :defaultSelection="this.selectedLocation" :xp_type="this.selectedExperience" device="desktop" :showMap="true" :showTitle="true" :showList="true"/>
          </fieldset>
          <!-- Location Content - Mobile -->
          <fieldset v-show="this.locationFilterSelectedModal" class="article-filter-dropdown location">
            <a href="#" @click.prevent="hideModal('loc')" class="icon-close modal-icon-close"></a>
              <FilterByLocation :defaultSelection="this.selectedLocation" :xp_type="this.selectedExperience" device="mobile" :showMapMobile="false" :showTitle="true" :showList="true"/>
          </fieldset>
        </div>
      </div>
    </div>
    <span>
      <b-spinner v-if="this.showLoading" small label="Small Spinner"></b-spinner>
    </span>
    <div v-if="!this.showLoading && Attractions.length === 0">
        <FilterEmptyState :Attractions="Attractions" />
    </div>
    <div v-else>
        <FilterResults :convertToDate="convertToDate" :getLink="getLink" :Attractions="Attractions" />
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { convertToDate } from '../../../store/helpers/helpers';
import FilterByLocation from '../Regions/Filters/Location/FilterByLocation.vue';
import FilterEmptyState from './AttractionFilterEmptyState.vue';
import FilterResults from './AttractionFilterResults.vue';
import IconBase from '../../Common/icons/index.vue';

export default {
  props: {
    defaultSearch: {
      type: String,
    },
    citySlug: {
      type: String,
    },
    area: {
      type: String,
    },
    experienceId: {
      type: [Number, String],
      default: '',
    },
  },
  async created() {
    this.$root.$on('currentLocation', (loc) => {
      this.selectedLocation = loc;
    });
    const self = this;
    axios.get(`${process.env.VUE_APP_API2}destinationFilters`)
      .then((response) => {
        self.Filters = response.data;
        if (self.area) {
          self.selectedLocation = self.area;
        }
        if (this.experienceId) {
          this.selectedExperience = this.experienceId;
          // Store initial selected experience
          const experienceMap = {
            1: 'history',
            2: 'beaches',
            3: 'food-and-drink',
            4: 'arts-and-culture',
            5: 'civil-rights-legacy',
            6: 'music',
            7: 'golf',
            8: 'outdoors',
            9: 'science',
            10: 'sports',
          };
          this.pendingFilters.experience = experienceMap[this.experienceId];
        }
        this.setState();
      });

    // handle Default search on load
    let defaultSearchString;
    defaultSearchString = `locationId=${this.defaultSearch}&limit=20`;
    if (this.citySlug) {
      defaultSearchString = `cityId=${this.citySlug}&limit=20`;
    }
    if (this.experienceId) {
      defaultSearchString = `experience_types=${this.experienceId}&limit=20`;
    }

    await this.$store.dispatch('maps/setArea', self.area);
    // await this.$store.dispatch('maps/updateLocations');
    let locations = [];
    try {
      await axios.get(`${process.env.VUE_APP_API2}filterLocations?${defaultSearchString}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      }).then((response) => { locations = response.data.locations.filter(attraction => attraction.imageUrl != null).slice(0, 7); });
    } catch (error) {
      console.log(error);
    }

    let events = [];
    try {
      await axios.get(`${process.env.VUE_APP_API2}searchEvents?${defaultSearchString}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      }).then((response) => {
        events = response.data.events.filter(event => event.imageUrl != null).slice(0, 6);
      });
    } catch (error) {
      console.log(error);
    }

    this.Attractions = locations.concat(events);

    this.$root.$on('updateAttractions', async (value) => {
      this.showPopover = false;
      setTimeout(() => {
        this.showAttractions = false;
        this.showLoading = true;
      }, 300);
      setTimeout(() => {
        this.showPopover = true;
        this.showLoading = false;
        this.Attractions = value;
        this.showAttractions = true;
      }, 500);
    });

    this.$root.$on('setDevice', () => {
      // Close the filter dropdowns
      this.locationFilterSelected = !this.locationFilterSelected;
      this.isActiveLocation = false;
    });
  },
  data() {
    return {
      selectedExperience: null,
      selectedLocation: '',
      showLoading: false,
      isActive: false,
      isActiveLocation: false,
      Filters: {
        experiences: [],
        locations: [],
      },
      Attractions: [],
      AreasReference: {
        'north-alabama': 0,
        'central-alabama': 1,
        'south-alabama': 2,
        'the-gulf-coast': 3,
      },
      linkMap: {
        1: '/places-to-go/map/experiences/History',
        2: '/places-to-go/map/experiences/Beaches',
        3: '/places-to-go/map/experiences/Food',
        4: '/places-to-go/map/experiences/Arts-And-Culture',
        5: '/places-to-go/map/experiences/Civil-Rights-Legacy',
        6: '/places-to-go/map/experiences/Music',
        7: '/places-to-go/map/experiences/Year-Round-Golf',
        8: '/places-to-go/map/experiences/Outdoors',
        9: '/places-to-go/map/experiences/Science-And-Discovery',
        10: '/places-to-go/map/experiences/Sports',
      },
      filters: {
        region: [],
        experience: [],
        location: [],
      },
      pendingFilters: {
        region: [],
        experience: [],
        location: [],
      },
      experienceFilterSelected: false,
      experienceFilterSelectedModal: false,
      locationFilterSelected: false,
      locationFilterSelectedModal: false,
      experiences: [
        {
          slug: 'arts-and-culture',
          iconUrl: '/images/nav/icons/ex-pin-arts-culture.svg',
          text: 'Arts & Culture',
        },
        {
          slug: 'beaches',
          iconUrl: '/images/nav/icons/ex-pin-beaches.svg',
          text: 'Beaches',
        },
        {
          slug: 'civil-rights-legacy',
          iconUrl: '/images/nav/icons/ex-pin-civil-rights-legacy.svg',
          text: 'Civil Rights Legacy',
        },
        {
          slug: 'food-and-drink',
          iconUrl: '/images/nav/icons/ex-pin-food-drink.svg',
          text: 'Food & Drink',
        },
        {
          slug: 'history',
          iconUrl: '/images/nav/icons/ex-pin-history.svg',
          text: 'History',
        },
        {
          slug: 'music',
          iconUrl: '/images/nav/icons/ex-pin-music.svg',
          text: 'Music',
        },
        {
          slug: 'outdoors',
          iconUrl: '/images/nav/icons/ex-pin-outdoors.svg',
          text: 'Outdoors',
        },
        {
          slug: 'science',
          iconUrl: '/images/nav/icons/ex-pin-science-exploration.svg',
          text: 'Science & Discovery',
        },
        {
          slug: 'sports',
          iconUrl: '/images/nav/icons/ex-pin-sports.svg',
          text: 'Sports',
        },
        {
          slug: 'golf',
          iconUrl: '/images/nav/icons/ex-pin-year-round-golf.svg',
          text: 'Year-Round Golf',
        },
      ],
    };
  },
  methods: {
    convertToDate,
    getLink() {
      if (this.selectedExperience) {
        return this.linkMap[this.selectedExperience] || '/places-to-go/map/Attractions';
      }
      return '/places-to-go/map/Attractions';
    },
    async handleExperienceType(device) {
      this.isActive = false;
      this.Attractions = [];
      this.showLoading = true;

      if (device === 'mobile') {
        this.toggleExperienceFilterModal();
      } else {
        this.toggleExperienceFilter();
      }

      try {
        const experienceParam = `&experience_types=${this.selectedExperience}`;
        let locationParam = this.selectedLocation ? `&area=${this.selectedLocation}` : '';
        let locationParamForEvent = this.selectedLocation ? `&areaId=${this.selectedLocation}` : '';

        // Remove the comma from the location params
        locationParam = locationParam.replace(',', '');
        locationParamForEvent = locationParamForEvent.replace(',', '');

        if (typeof this.selectedLocation === 'string') {
          const [locationsResponse, eventsResponse] = await Promise.all([
            this.fetchLocations(experienceParam, locationParam),
            this.fetchEvents(experienceParam, locationParamForEvent),
          ]);

          this.updateAttractions(locationsResponse.data.locations, eventsResponse.data.events);
        } else {
          const allExperienceLocations = [];
          const allEvents = [];

          await Promise.all(this.selectedLocation.flat().filter(n => n).map(async (loc) => {
            locationParam = `&area=${loc}`;
            locationParamForEvent = `&areaId=${loc}`;
            const [locationsResponse, eventsResponse] = await Promise.all([
              this.fetchLocations(experienceParam, locationParam),
              this.fetchEvents(experienceParam, locationParamForEvent),
            ]);

            allExperienceLocations.push(locationsResponse.data.locations);
            allEvents.push(eventsResponse.data.events);
          }));

          this.updateAttractions(allExperienceLocations.flat(), allEvents.flat());
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.showLoading = false;
      }
    },
    toggleExperienceFilterModal() {
      this.experienceFilterSelectedModal = !this.experienceFilterSelectedModal;
      this.$refs['exp-modal'].hide();
    },
    toggleExperienceFilter() {
      this.experienceFilterSelected = !this.experienceFilterSelected;
    },
    fetchLocations(experienceParam, locationParam) {
      return axios.get(`${process.env.VUE_APP_API2}filterLocations?${experienceParam + locationParam}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      });
    },
    fetchEvents(experienceParam, locationParamForEvent) {
      return axios.get(`${process.env.VUE_APP_API2}searchEvents?${experienceParam + locationParamForEvent}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      });
    },
    updateAttractions(locations, events) {
      const experienceLocations = this.shuffle(locations).filter(location => location.imageUrl != null).slice(0, 7);
      const filteredEvents = events.filter(event => event.imageUrl != null).slice(0, 6);

      this.Attractions = this.filterDuplicates([...experienceLocations, ...filteredEvents]);
    },
    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
      }
      return arr;
    },
    async setState() {
      await this.$store.dispatch('maps/setLocationTypes', ['attraction', 'retail', 'shoppingDestination', 'venue', 'service']);
      await this.$store.dispatch('maps/setArea', this.selectedLocation || null);
      await this.$store.dispatch('maps/setSelectedTab', !this.selectedExperience ? 'see' : 'experiences');
      // await this.$store.dispatch('maps/setSelectedTab', 'see');
      await this.$store.dispatch('maps/setExperienceType', this.selectedExperience ? [this.selectedExperience] : []);
    },
    isFavorite(objectid) {
      return this.$store.getters['favorites/isFavorite'](objectid);
    },
    toggleFilterDropdown(filter) {
      if (filter === 'experience') {
        if (this.isActiveLocation) {
          this.isActiveLocation = !this.isActiveLocation;
        }
        this.isActive = !this.isActive;
        this.experienceFilterSelected = !this.experienceFilterSelected;
        this.locationFilterSelected = false;
      } else if (filter === 'location') {
        if (this.isActive) {
          this.isActive = !this.isActive;
        }
        this.isActiveLocation = !this.isActiveLocation;
        this.locationFilterSelected = !this.locationFilterSelected;
        this.experienceFilterSelected = false;
      }
    },
    selectExperienceFilter(experience) {
      const experienceMap = {
        history: 1,
        beaches: 2,
        'food-and-drink': 3,
        'arts-and-culture': 4,
        'civil-rights-legacy': 5,
        music: 6,
        golf: 7,
        outdoors: 8,
        science: 9,
        sports: 10,
      };
      // If the experience is already selected, remove it
      if (!this.pendingFilters.experience.includes(experience)) {
        this.selectedExperience = experienceMap[experience];
        // Store the selected experience
        this.pendingFilters.experience = [experience];
      }
    },
    hideModal(type) {
      if (type === 'exp') {
        this.$refs['exp-modal'].hide();
      } else if (type === 'loc') {
        this.$refs['loc-modal'].hide();
      }
    },
    filterDuplicates(array) {
      return Array.from(new Set(array));
    },
  },
  components: {
    FilterByLocation,
    FilterEmptyState,
    FilterResults,
    IconBase,
  },
};
</script>
<style lang="scss" scoped>
a {
  color: #173945;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }

  &:visited {
    color: #4d5a67;
  }
}

h3 {
  font-size: 1.1rem;
}

.attractions-section {
  margin-top: 150px;
}

.card-body {
  background-color: #fff;
  padding: 0px;
  text-align: left;

  @media only screen and (min-width: 769px) {
    padding: 25px;
  }
}

.card-body:hover {
  cursor: pointer;
}

h2,
.h2 {
  color: #173945;
  display: block;
  font-family: 'klinicslabbold';
  font-size: 2rem;
  line-height: 3rem;
}

.h2--feel,
.h2--in {
  display: block;

  @media screen and (min-width: 768px) {
    display: inline-block;
  }

}

select {
  margin-bottom: 1rem;
}

h2.find-sweet-spot-title {
  width: 19rem;
  margin: 0 auto;

  @media screen and (min-width: 666px) {
     width: 100%;
  }
}
.find-sweet-spot-txt {
  display: inline-block;
  width: 20rem;
  height: 85px;
  margin: 10px 0 40px 0;
  font-family: "IdealSans-Book";
  font-style: normal;
  font-weight: 325;
  font-size: 15px;
  line-height: 23px;
  text-align: center;

  @media screen and (min-width: 666px) {
     width: 600px;
  }
  @media screen and (min-width: 767px) {
     width: 655px;
  }
}

.filter-button.experience-select.mobile, .filter-button.location-select.mobile {
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;

  @media screen and (min-width: 930px) {
    display: none;
  }
}
.filter-button.experience-select.desktop, .filter-button.location-select.desktop {
  display: none;

  @media screen and (min-width: 930px) {
    display: inline-block;
  }
}
.articles-container {

  .filter-dropdown-container {

    legend {
      margin: 0;
      color: #1a3138;
      text-align: center;
      font-family: 'klinicslabbold';
      font-size: 1.125rem;
      line-height: normal;
      display: contents;
    }

    .article-filter-dropdown {
      position: fixed;
      background-color: white;
      padding: 0 1.5rem 3rem;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      right: 0%;
      left: 0%;
      top: 70px;
      margin: auto;
      overflow: scroll;
      width: 26rem;
      height: 101vh !important;
      margin-top: -70px;
      z-index: 99;

      @media screen and (min-width: 930px) {
          margin-top: 1rem;
        }

      &.experience {
        @media screen and (min-width: 930px) {
          position: absolute;
          padding: 1rem 1.5rem;
          top: 50px;
          border: 1px solid rgba(37, 37, 37, 0.2);
          width: 31rem !important;
          height: auto !important;
          right: 5%;
        }
      }
      &.location {
        @media screen and (min-width: 930px) {
          position: absolute;
          padding: 1rem 1.5rem;
          top: 60px;
          border: 1px solid rgba(37, 37, 37, 0.2);
          width: 55rem !important;
          height: 26.5rem !important;
        }
      }

      .filter-experience-container {
        display: flex;
        flex-wrap: wrap;
        column-gap: 1.75rem;
        row-gap: 1.25rem;
        list-style: none;
        margin: 0;
        padding: 0;
      }

      .experience-filter {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        border-radius: 2.25rem;
        border: 1px solid #eaeaea;
        padding: 0.5rem 1rem;
        color: #333;
        font-size: 0.875rem;
        background: white;
        cursor: pointer;
        user-select: none;

        img {
          width: 1.5rem;
          height: 1.5rem;
        }

        &[aria-selected='true'] {
          border: 1px solid #173945;
          -webkit-box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
          box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
        }

        &:hover {
          -webkit-box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
          box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
          -webkit-transition: all 0.3s ease-in-out;
          transition: all 0.3s ease-in-out;
        }
      }

      .filter-checklist {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        list-style: none;
        margin: 0;
        padding: 0;

        input {
          min-width: 0;
        }
      }

      .filter-save-button {
        color: white;
        padding: 0.25rem 1.25rem;
        margin-top: 0px;
        background-color: #173945;
        font-size: 1.25rem;
        align-self: flex-end;
        border-radius: 0.5rem;
        border: none;
        font-family: 'klinicslabbold';

        &:hover,
        &:focus-visible {
          background-color: #316273;
        }
        @media screen and (min-width: 930px) {
          margin-top: -50px;
        }
      }
    }
  }
}

.experience-select, .location-select {
  background-color: #fff;
  background-size: 25px;
  background-repeat: no-repeat;
  background-position: right 10px center;
  border: 1px solid #4e97b2;
  color: #173945;
  display: inline-block;
  font-family: 'klinicslabbold';
  fill: #173945;
  content: "\e904";
  min-width: 230px;
}

.experience-select, .location-select {
  position: relative;
}

.experience-select, .experience-select-active {
  min-width: 213px !important;
  margin-left: 0px;
  margin-top: 10px;
  width: 213px;
  height: 48px;
  border: 1px solid #EAEAEA;
  border-radius: 25px;
  background: none;
  background-size: 13px;
  background-position: right 30px center;
  fill: #173945 !important;

  @media screen and (min-width: 768px) {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 0px;
  }
}
.location-select, .location-select-active {
  min-width: 213px !important;
  margin-left: 0px;
  margin-top: 10px;
  width: 213px;
  height: 48px;
  border: 1px solid #EAEAEA;
  border-radius: 25px;
  background: none;
  background-size: 13px;
  background-position: right 30px center;
  fill: #173945 !important;

  @media screen and (min-width: 666px) {
    min-width: 149px !important;
    width: 149px;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 0px;
  }
}

.experience-select.mobile {
  margin-left: 0px;;
}
.experience-select-active, .location-select-active {
  border: 1px solid #173945;
}

.experience-select-txt {
  font-family: "IdealSans-Book";
  font-style: normal;
  font-weight: 325;
  font-size: 15px;
  line-height: 23px;
  margin-right: -15px;
  float: left;
  margin-left: 25px;
  margin-top: 3px;
}
.location-select-txt {
  font-family: "IdealSans-Book";
  font-style: normal;
  font-weight: 325;
  font-size: 15px;
  line-height: 23px;
  margin-right: -5px;
  float: left;
  margin-left: 45px !important;
  margin-top: 3px;

  @media screen and (min-width: 666px) {
    margin-left: 15px !important;
  }
}

// MODAL STYLES
.modal-icon-close-exp {
  color: #4e97b2 !important;
  cursor: pointer;
  position: absolute;
  right: -5rem;
  top: -50px;
  z-index: 9999;

  @media screen and (max-width: 666px) {
    right: 0rem;
    top: -2rem;
  }
  @media screen and (min-width: 768px) {
    right: -7rem;
    top: 0px;
  }
}

.modal-icon-close:hover {
  color: #000 !important;
}
.exp-title-txt {
  margin-top: 100px;
}

legend {
  color: #1a3138;
  text-align: center;
  font-family: 'klinicslabbold';
  font-size: 25px !important;
  font-weight: 400;
  line-height: normal;
}

.article-filter-dropdown.location {
  position: fixed;
  background-color: white;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  right: 0%;
  left: 0%;
  margin: auto;
  width: 100vw !important;
  height: 100vh !important;
  margin-top: 0px;
  z-index: 99;
}
.article-filter-dropdown.experience {
  position: fixed;
  background-color: white;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  right: 0%;
  left: 0%;
  top: 70px;
  margin: auto;
  width: 23rem !important;
  height: 100vh !important;
  margin-top: 0;
  z-index: 99;
}

.filter-experience-container {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.75rem;
  row-gap: 1.25rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.experience-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 2.25rem;
  border: 1px solid #eaeaea;
  padding: 0.5rem 1rem;
  color: #333;
  font-size: 0.875rem;
  background: white;
  cursor: pointer;
  user-select: none;
}

.experience-filter > img {
  width: 1.5rem;
  height: 1.5rem;
}

.experience-filter {
  &[aria-selected='true'] {
    border: 1px solid #173945;
    -webkit-box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
    box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
  }

  &:hover {
    -webkit-box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
    box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1), 0px 0px 1px 0px rgba(10, 22, 70, 0.06);
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
}

.filter-save-button {
  color: white;
  padding: 0.25rem 1.25rem;
  margin-top: 0px;
  background-color: #173945;
  font-size: 1.25rem;
  align-self: flex-end;
  border-radius: 0.5rem;
  border: none;
  font-family: 'klinicslabbold';
  float: right;

  &:hover,
  &:focus-visible {
    background-color: #316273;
  }
  @media screen and (min-width: 930px) {
    margin-top: -50px;
  }
}

a.button {
  color: #ffffff;
  display: inline-block;
}
</style>
